import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import { useQueryClient } from 'react-query';
import AccountsBlock from '../../components/ui/AccountsBlock/AccountsBlock';
import { getQueryKeys } from '../../queries/queryKeys';
import { getEntitiesWithAddress } from '../../utils/getEntitiesWithAddress';
import styles from './PersonalAccountsPage.module.scss';

const PersonalAccountsPage = () => {
  const queryClient = useQueryClient();

  const [accounts, setAccounts] = useState([]);

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const { data: housingStock, isFetching: isHousingStockFetching } =
    queryClient.getQueryState(getQueryKeys.housingStock(currentCompany?.id));

  useEffect(() => {
    if (housingStock?.length) {
      const accounts = getEntitiesWithAddress(housingStock, 'accounts');

      setAccounts(accounts);
    }
  }, [housingStock]);

  return (
    <Spin spinning={isHousingStockFetching}>
      <article className={styles.container}>
        <AccountsBlock accounts={accounts} />
      </article>
    </Spin>
  );
};

export default PersonalAccountsPage;
